import { Component } from '@headless-workspace/typings';

export const FilterSection: Component = () => {
    return (
        <section id={'product-list-filters'} className={'flex-col px-1.5 hidden desktopS:flex'}>
            <div className={'min-w-[200px] h-full bg-background-skeleton'}>Filters</div>
        </section>
    );
};
